import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';

import { Label, Message, Header, Image } from 'semantic-ui-react';

import * as shareLib from 'libs/shareLib';
import * as shareActions from 'modules/share';
import * as loginActions from 'modules/login';
import * as userActions from 'modules/user';

import { clearReduxStore } from 'containers/InitialStore';
import { ServiceShareChangeService, ModalTemplate, Button } from 'components';

class CtServiceShareChangeService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      aModal: false,
      noModal: ''
    };

    this.changeShareService = this.changeShareService.bind(this);
  }

  onToggleModal = value => {
    this.setState({ noModal: value });
  };

  mountAModal = () => {
    const { aModal } = this.state;

    if (aModal) {
      // 열려진 경우로 닫는다.
      this.setState({ aModal: false, onProgress: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ aModal: true, onProgress: false });
    }
  };

  changeShareService = async () => {
    this.setState({ onProgress: true });

    const { shareInfo: { userServiceNo } } = this.props;

    const params = {};
    let isOk = true;
    if (userServiceNo) {
      params.userServiceNo = userServiceNo;
    } else {
      // 오류
      isOk = false;
    }

    let isChange = false;
    if (isOk) {
      try {
        const { LoginActions } = this.props;
        await LoginActions.changeService(params);

        const { loginResult, UserActions, userData, sessionTimeout, location, match, history, Dispatch } = this.props;
        if (loginResult === 1) {
          isChange = true;
          await UserActions.setUser({ user: userData, sessionTimeout });

          // 좀 더 매끄럽게 전환되는 방법 모색해야 함
          window.location.reload();
        } else if (loginResult === 3) {
          // No Allow Accesss Ip
          this.onToggleModal('noModal');
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('changeShareService isOk fail!');
    }

    if (!isChange) {
      this.mountAModal();
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, aModal, noModal } = this.state;
    const { isAuth, shareInfo, myInfo } = this.props;
    const { mountAModal, changeShareService, onToggleModal } = this;

    const { serviceNo, serviceName, serviceUserName, serviceUserEmail } = shareInfo;
    const { userNo, originalServiceNo, serviceNo: currentServiceNo } = myInfo;

    return (
      <div>
        <Label basic as="a" onClick={mountAModal} className="service-label">
          {/* <Icon size="large" circular inverted name="home" color={originalServiceNo === serviceNo ? 'teal' : 'grey'} /> */}
          {serviceNo === currentServiceNo ? (
            <Image src="/img/headerShare/share-on.png" />
          ) : (
            <Image src="/img/headerShare/share-off.png" />
          )}
          <div className={serviceNo === currentServiceNo ? 'service-box-selected' : 'service-box'}>
            <div className="service-title">
              {serviceName}
              {serviceNo === currentServiceNo && <Image src="/img/headerShare/selected.png" />}
            </div>
            <div className="service-sub-title">
              {originalServiceNo === serviceNo
                ? defineMessages(formatMessage({ id: 'CtServiceShareChangeService_1', defaultMessage: '내 서비스' }))
                : serviceUserName + ' (' + serviceUserEmail + ')'}
            </div>
          </div>
        </Label>
        {aModal && (
          <ServiceShareChangeService
            onProgress={onProgress}
            isAuth={isAuth}
            shareInfo={shareInfo}
            changeShareService={changeShareService}
            handleOnToggleAModal={mountAModal}
          />
        )}
        {noModal === 'noModal' && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className="modal-examAlert-area common-content"
            visible
            onToggleModal={onToggleModal}
            header={'서비스 변경 불가'}
            buttons={
              <div className="inline-block">
                <Button
                  buttonColor="#bbbbbb"
                  onClick={() => {
                    onToggleModal('');
                  }}>
                  {defineMessages(formatMessage({ id: 'ServiceShareChangeService_2', defaultMessage: '닫 기' }))}
                </Button>
              </div>
            }>
            <div className="modal-content">
              <Message className="template-detail-box">
                <div className="template-detail">
                  <div>{'허용된 IP가 아닙니다.'}</div>
                  <div>{'서비스 변경이 제한됩니다.'}</div>
                </div>
              </Message>
            </div>
          </ModalTemplate>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth'),
    loginResult: state.login.getIn(['login', 'loginResult']),
    userData: state.login.getIn(['login', 'userData']),
    sessionTimeout: state.login.getIn(['login', 'sessionTimeout'])
  };
};

const mapDispatchToProps = dispatch => ({
  ShareActions: bindActionCreators(shareActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch),
  Dispatch: dispatch
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtServiceShareChangeService)));



// WEBPACK FOOTER //
// ./src/script/containers/share/CtServiceShareChangeService.js